
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import ProductsView from '@/components/Products/ProductsView';
import {
  getCategories,
  getCountries,
  getProducts,
  getManufacturers,
  getIndustryCategories,
} from '@/lib/utilities/repository';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { SWRConfig } from 'swr';
import {
  getUseProductCacheKey,
  useNativeCategorySlug,
  useNativeIndustryCategorySlug,
} from '@/lib/hooks/fetchers/useProducts';
import {
  initialState,
  loadFiltersFromUrlParams,
} from '@/components/Form/ProductsFilter/productsFilterSlice';
import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { useAppDispatch } from '@/app/hooks';

interface ProductListProps {
  fallback: any;
}

function ProductsIndex(props: ProductListProps) {
  const router = useRouter();
  const { t } = useTranslation();
  useUpdateFiltersByUrl();

  return (
    <>
      <SWRConfig value={{ fallback: props.fallback }}>
        <NextSeo
          title={t('common:SEO_PRODUCT_LIST_TITLE')}
          description={t('common:SEO_PRODUCT_LIST_DESCRIPTION')}
          openGraph={{
            url: process.env.SITE_URL_EN,
            title: t('common:SEO_PRODUCT_LIST_OPEN_GRAPH_TITLE'),
            description: t('common:c'),
            site_name: 'BEVMAQ',
            type: 'article',
          }}
          canonical={router.asPath}
        />
        <ProductsView />
      </SWRConfig>
    </>
  );
}

export function useUpdateFiltersByUrl() {
  const dispatch = useAppDispatch();
  const category_slug = useNativeCategorySlug();
  const industry_category_slug = useNativeIndustryCategorySlug();
  useEffect(() => {
    console.log('loading from url');
    dispatch(loadFiltersFromUrlParams());
  }, [dispatch, category_slug, industry_category_slug]);
}

 const _getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context;
  return {
    props: {
      fallback: {
        [getUseProductCacheKey(initialState, locale)]: await getProducts({
          locale,
        }),
        [`/api/industry-categories/${locale}`]: await getIndustryCategories(
          locale
        ),
        [`/api/categories/${locale}`]: await getCategories(locale),
        [`/api/countries/${locale}`]: await getCountries(locale),
        [`/api/manufacturers/${locale}`]: await getManufacturers(locale),
      },
    },
    // After this amount of seconds if the page gets a request
    // next will regenerate a page for the next users
    revalidate: 120,
  };
};

export default ProductsIndex;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/buy/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  